import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  EditBorrowerPropertyOwnerDialogData,
  EditBorrowerPropertyOwnerDialogResult,
  YesNoValue,
} from '@portal-workspace/grow-shared-library';
import { MatButtonModule } from '@angular/material/button';
import { FlexModule } from '@angular/flex-layout/flex';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { tap } from 'rxjs';
import { YesNoComponent } from '../yes-no-component/yes-no.component';

@UntilDestroy()
@Component({
  templateUrl: './edit-borrower-property-owner.dialog.html',
  styleUrls: ['./edit-borrower-property-owner.dialog.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FlexModule,
    MatButtonModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    YesNoComponent,
  ]
})
export class EditBorrowerPropertyOwnerDialog {

  formGroup: FormGroup<{
    borrowerEntityPropertyOwner: FormControl<YesNoValue>;
  }>;

  formControlBorrowerEntityPropertyOwner: FormControl<YesNoValue>;

  isSaving = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: EditBorrowerPropertyOwnerDialogData,
    private matDialogRef: MatDialogRef<EditBorrowerPropertyOwnerDialog, EditBorrowerPropertyOwnerDialogResult>,
    private formBuilder: FormBuilder
  ) {
    this.formControlBorrowerEntityPropertyOwner = formBuilder.control<YesNoValue>(
      !!this.data.application.isBorrowerPropertyOwner,
      [Validators.required],
    );

    this.formGroup = formBuilder.group({
      borrowerEntityPropertyOwner: this.formControlBorrowerEntityPropertyOwner,
    });
  }

  onCancel(): void {
    this.matDialogRef.close({ updated: false });
  }

  onSubmit(): void {
    if (this.formGroup.valid && !this.isSaving) {
      this.isSaving = true;

      this.data.updateApplicationBorrowerPropertyOwnerFn({
        applicationId: this.data.application.ApplicationId,
        isBorrowerPropertyOwner: !!this.formControlBorrowerEntityPropertyOwner.value,
      }).pipe(
        untilDestroyed(this),
        tap({
          next: (response) => {
            this.isSaving = false;
            if (response.status) {
              this.matDialogRef.close({ updated: true });
            }
          },
          error: (error) => {
            this.isSaving = false;
            console.error('Failed to update borrowing entity property owner', error);
          }
        })
      ).subscribe();
    }
  }
}
